import { AnyAction } from "redux";
import { SET_CURRENCY_CODES_LOADED } from "../actions/loadingCurrencyCodes";

export const loadingCurrencyCodes = (state = false, action: AnyAction) => {
  switch (action.type) {
    case SET_CURRENCY_CODES_LOADED:
      return action.currencyCodesLoaded;
    default:
      return state;
  }
};

export default loadingCurrencyCodes;
